import React from 'react';

/**
 * Sekme navigasyonu bileşeni
 * 
 * @param {Object} props - Bileşen özellikleri
 * @param {Array} props.items - Sekme öğeleri dizisi (her öğe {id, label} şeklinde)
 * @param {string} props.activeTab - Aktif sekme kimliği
 * @param {Function} props.onTabChange - Sekme değiştiğinde çağrılacak fonksiyon
 * @param {string} props.variant - Sekme varyantı ('underline', 'pills', 'tabs')
 * @param {string} props.color - Sekme rengi ('indigo', 'blue', 'gray')
 */
const TabNavigation = ({ 
  items = [], 
  activeTab, 
  onTabChange,
  variant = 'underline',
  color = 'indigo'
}) => {
  // Aktif renk sınıfını belirle
  const getActiveColorClass = () => {
    switch (color) {
      case 'blue':
        return variant === 'underline' ? 'text-blue-600 border-blue-600' : 'bg-blue-600 text-white';
      case 'gray':
        return variant === 'underline' ? 'text-gray-800 border-gray-800' : 'bg-gray-700 text-white';
      case 'indigo':
      default:
        return variant === 'underline' ? 'text-indigo-600 border-indigo-600' : 'bg-indigo-600 text-white';
    }
  };

  // Sekme konteyner sınıfını belirle
  const getContainerClass = () => {
    switch (variant) {
      case 'pills':
        return 'flex space-x-2 p-1 bg-gray-100 rounded-lg';
      case 'tabs':
        return 'flex border-b border-gray-200';
      case 'underline':
      default:
        return 'flex border-b border-gray-200';
    }
  };

  // Sekme öğesi sınıfını belirle
  const getTabItemClass = (isActive) => {
    const activeClass = getActiveColorClass();
    const baseClass = 'font-medium transition-colors duration-200';
    
    switch (variant) {
      case 'pills':
        return `${baseClass} px-4 py-2 rounded-lg ${isActive ? activeClass : 'text-gray-600 hover:bg-gray-200'}`;
      case 'tabs':
        return `${baseClass} px-4 py-3 ${isActive ? `${activeClass} border-t-2 border-r border-l rounded-t-lg -mb-px bg-white` : 'text-gray-600 hover:text-gray-800'}`;
      case 'underline':
      default:
        return `${baseClass} px-4 py-3 ${isActive ? `${activeClass} border-b-2` : 'text-gray-600 hover:text-gray-800 hover:border-b-2 hover:border-gray-300'}`;
    }
  };

  return (
    <div className={getContainerClass()}>
      {items.map((item) => (
        <button
          key={item.id}
          className={`flex-1 ${getTabItemClass(activeTab === item.id)}`}
          onClick={() => onTabChange && onTabChange(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
